import { render, staticRenderFns } from "./ElementProperties.vue?vue&type=template&id=67d5403d"
import script from "./ElementProperties.vue?vue&type=script&lang=js"
export * from "./ElementProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports